import { render } from "./AddPraise.vue?vue&type=template&id=496360f2&scoped=true"
import script from "./AddPraise.vue?vue&type=script&lang=js"
export * from "./AddPraise.vue?vue&type=script&lang=js"

import "./AddPraise.vue?vue&type=style&index=0&id=496360f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496360f2"]])

export default __exports__